import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getPaymentHistory } from '../actions/payment-actions';
import paymentConstants from '../constants/payment-constants';
import ButtonsSelector from '../../../shared/buttons-selector/components/buttons-selector';
import DefaultLoader from '../../../shared/default-loader/components/default-loader';
import RenderIf from '../../../shared/render-if/components/render-if';
import PaymentHistoryTable from './payment-history-table';
import PaymentHistoryNoTransactions from './payment-history-no-transactions';
import PageHeader from '../../../shared/page-header/components/page-header';

class PaymentHistory extends Component {
  state = {
    paymentStatus: paymentConstants.payment_statuses.pending,
  };
  componentDidMount() {
    const { getPaymentHistory } = this.props;
    const { paymentStatus } = this.state;

    getPaymentHistory(paymentStatus.value);
  }

  handlePaymentStatusChange(item) {
    const { getPaymentHistory } = this.props;

    this.setState({ paymentStatus: item });
    getPaymentHistory(item.value);
  }

  render() {
    const { payments, httpInProgress } = this.props;
    const { paymentStatus } = this.state;
    const buttonItems = _.values(paymentConstants.payment_statuses);

    return (
      <div className="payment-history-container">
        <PageHeader title={'PAYMENTS.HISTORY'} />
        <ButtonsSelector items={buttonItems} selectedValue={paymentConstants.payment_statuses.pending} onClick={item => this.handlePaymentStatusChange(item)} />
        <RenderIf if={payments && payments.length > 0 && !httpInProgress}>
          <PaymentHistoryTable payments={payments} />
        </RenderIf>
        <RenderIf if={payments && payments.length === 0 && !httpInProgress}>
          <PaymentHistoryNoTransactions status={paymentStatus.label} />
        </RenderIf>
        <RenderIf if={!payments || httpInProgress}>
          <div className="display-flex-center p-t-50 p-b-50">
            <DefaultLoader />
          </div>
        </RenderIf>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  payments: state.paymentsReducer.payments,
  httpInProgress: state.httpInProgressReducer.httpInProgress,
});

const mapDispatchToProps = dispatch => ({
  getPaymentHistory: statuses => {
    dispatch(getPaymentHistory(statuses));
  },
});

PaymentHistory.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentHistory);



// WEBPACK FOOTER //
// ./src/app/main/payments/components/payment-history.js